/**
 * Reorder
 */
(function () {
    const reorderPopovers = document.querySelectorAll('.ReorderPopover');
    reorderPopovers.forEach((popover) => {
        const addButton = popover.querySelector('.Reorder__AddButton');
        if (addButton) {
            addButton.addEventListener('click', (e) => {
                const target = e.target;
                const items = JSON.parse(target.getAttribute('data-items')).items;
                window.waitForFunction("addToCart", [items]);
            });
        }
    });
})();
/**
 * Account panel visibility
 */
(function () {
    const sectionButtons = document.querySelectorAll('.AccountNavigation__Item[data-section-nav]'), sections = document.querySelectorAll('[data-account-section]'), formatSectionName = (sectionName, forUrl = false) => {
        if (forUrl) {
            return sectionName.replaceAll(' ', '_');
        }
        else {
            return sectionName.replaceAll('_', ' ');
        }
    };
    if (sectionButtons.length === 0 || sections.length === 0) {
        return;
    }
    // Listeners on nav buttons to trigger selection change
    sectionButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            const target = e.target;
            document.dispatchEvent(new CustomEvent('account:item:changed', { detail: target.getAttribute('data-section-nav') }));
        });
    });
    // Listeners on collapsible buttons to trigger selection change
    sections.forEach((section) => {
        const collapsibleButton = section.querySelector('.Collapsible__Button');
        if (!collapsibleButton)
            return;
        collapsibleButton.addEventListener('click', (e) => {
            const target = e.target;
            document.dispatchEvent(new CustomEvent('account:item:changed', { detail: target.closest('[data-account-section]').getAttribute('data-account-section') }));
        });
    });
    // Handle changes of the selected account item
    document.addEventListener('account:item:changed', (e) => {
        const customEvent = e;
        const sectionName = customEvent.detail;
        // Handle section visibility
        sections.forEach((section) => {
            const collapsibleButton = section.querySelector('.Collapsible__Button');
            if (window.handleize(section.getAttribute('data-account-section')) === window.handleize(sectionName)) {
                section.classList.remove('md:none');
                section.classList.add('md:block');
                // Open collapsible (mobile) for non-mobile screens
                if (window.matchMedia('screen and (min-width: 768px)').matches && collapsibleButton.getAttribute('aria-expanded') == 'false') {
                    const inner = section.querySelector('.Collapsible__Inner');
                    collapsibleButton.setAttribute('aria-expanded', 'true');
                    inner.style.overflow = 'visible';
                    inner.style.height = 'auto';
                    section.style.overflow = 'visible';
                }
            }
            else {
                section.classList.remove('md:block');
                section.classList.add('md:none');
                // Close inactive collapsible (mobile) for non-mobile screens
                if (window.matchMedia('screen and (min-width: 768px)').matches && collapsibleButton.getAttribute('aria-expanded') == 'true') {
                    collapsibleButton.setAttribute('aria-expanded', 'false');
                    resetCollapsibleStyles(section);
                }
            }
        });
        // Set current section button active
        sectionButtons.forEach((button) => {
            if (button.getAttribute('data-section-nav') === sectionName) {
                button.classList.add('is-active');
            }
            else {
                button.classList.remove('is-active');
            }
        });
        // Set url hash
        history.replaceState(null, '', '#' + formatSectionName(sectionName, true));
    });
    // Reset styles set through Collapsible functionality to make panel visibility work after screen width increases from mobile view
    const resetCollapsibleStyles = function (collapsible) {
        const inner = collapsible.querySelector('.Collapsible__Inner');
        collapsible.style.overflow = '';
        inner.style.overflow = '';
        inner.style.height = '';
    };
    sections.forEach((section) => {
        section.addEventListener('collapsible:closed', (e) => {
            resetCollapsibleStyles(e.target);
        });
    });
    // Check hash on initial page load
    const handleInitialHash = function () {
        if (window.themeJSReady) {
            const hash = window.location.hash.replace('#', '').split('?')[0], sectionName = formatSectionName(decodeURI(hash)), sectionButton = document.querySelector(`.AccountNavigation__Item[data-section-nav="${sectionName}"]`), collapsibleButton = document.querySelector(`[data-account-section="${sectionName}"] .Collapsible__Button`);
            if (sectionButton && !sectionButton.classList.contains('is-active')) {
                sectionButton.click();
            }
            if (collapsibleButton && window.matchMedia('screen and (max-width: 767px)').matches && collapsibleButton.getAttribute('aria-expanded') == 'false') {
                window.scrollTo({
                    behavior: 'smooth',
                    top: collapsibleButton.offsetTop
                });
                collapsibleButton.click();
            }
        }
        else {
            setTimeout(handleInitialHash, 100);
        }
    };
    handleInitialHash();
})();
/**
 * Diagnostic tests
 */
(function () {
    const activationModalId = 'modal-lab-test-activation', activationForm = document.querySelector(`#${activationModalId} form`);
    if (!activationForm)
        return;
    class API {
        static async verify(testId, customerId) {
            return new Promise((resolve, reject) => {
                fetch(`${this.URL}/verify`, {
                    method: 'POST',
                    body: JSON.stringify({
                        testCode: testId,
                        customerCode: customerId
                    }),
                    headers: {
                        'X-Vm-Token': window.theme.customerToken || '',
                        'X-Vm-Id': window.theme.customerId || '',
                        'Content-Type': 'application/json'
                    }
                }).then(response => {
                    if (response.status !== 200)
                        throw `[Error] Verify: API returned ${response.status}`;
                    return response.json();
                }).then(data => {
                    resolve(data.available);
                }).catch(err => {
                    reject(err);
                });
            });
        }
        static async activate(data) {
            return new Promise((resolve, reject) => {
                fetch(`${this.URL}/activate`, {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'X-Vm-Token': window.theme.customerToken || '',
                        'X-Vm-Id': window.theme.customerId || '',
                        'Content-Type': 'application/json'
                    }
                }).then(response => {
                    if (response.status !== 200)
                        throw `[Error] Activate: API returned ${response.status}`;
                    return response.json();
                }).then(data => {
                    resolve(data.success);
                }).catch(err => {
                    reject(err);
                });
            });
        }
    }
    API.URL = 'https://api.vitamoment.de/tests';
    function initModalOpeners(container) {
        container.querySelectorAll(`[data-action="open-modal"][aria-controls="${activationModalId}"]`).forEach(btn => {
            btn.addEventListener('click', () => {
                activationForm.dispatchEvent(new CustomEvent('theme:form:setstep', { detail: 1 }));
                // Set focus on input after transition ended
                activationForm.addEventListener('transitionend', () => {
                    const firstInput = activationForm.querySelector('[data-form-step="1"] [data-form-step-autofocus]');
                    if (firstInput)
                        firstInput.focus();
                }, { once: true });
            });
        });
    }
    initModalOpeners(document);
    activationForm.addEventListener('theme:form:step', async (e) => {
        const event = e;
        try {
            const customerId = event.detail.customerCode;
            let testId = event.detail.testCode;
            if (testId.length > 10)
                testId = testId.slice(0, 10);
            const success = await API.verify(testId, customerId);
            if (success) {
                activationForm.dispatchEvent(new CustomEvent('theme:form:continue', { detail: { successAlert: 'default' } }));
                const firstInput = activationForm.querySelector('[data-form-step="2"] [data-form-step-autofocus]');
                if (firstInput)
                    firstInput.focus();
            }
            else {
                activationForm.dispatchEvent(new CustomEvent('theme:form:alert', { detail: { name: 'invalid' } }));
            }
        }
        catch (err) {
            console.error(err);
            activationForm.dispatchEvent(new CustomEvent('theme:form:alert', { detail: { name: 'default' } }));
        }
    });
    activationForm.addEventListener('theme:form:submit', async (e) => {
        const event = e;
        try {
            if (event.detail.testCode.length > 10)
                event.detail.testCode = event.detail.testCode.slice(0, 10);
            await API.activate(event.detail);
            fetch(`${location.pathname}?section_id=lab-tests`).then(response => response.text()).then(html => {
                document.querySelector('#shopify-section-lab-tests').outerHTML = html;
                const newSectionElement = document.querySelector('#shopify-section-lab-tests');
                newSectionElement.querySelector('.LabTestsPanel__ActivationSuccessMessage').setAttribute('aria-hidden', 'false');
                newSectionElement.querySelector('[data-action="open-modal"][aria-controls="modal-lab-test-activation"]').innerText = 'Weiteren Test aktivieren';
                initModalOpeners(newSectionElement);
                activationForm.querySelector('input[name="testCode"]').value = '';
                activationForm.closest('.Modal').querySelector('[data-action="close-modal"]').click();
            }).catch(err => {
                console.error('Error reloading test section', err);
            }).finally(() => {
                activationForm.dispatchEvent(new CustomEvent('theme:form:done'));
            });
        }
        catch (err) {
            console.error(err);
            activationForm.dispatchEvent(new CustomEvent('theme:form:alert', { detail: { name: 'default' } }));
        }
    });
})();
/**
 * Club product slider
 */
(function () {
    const clubTabSwitches = document.querySelectorAll('.AccountSection .tab-switch [data-action="toggle-tab"]'), clubProductSlider = document.querySelector('.AccountProductSlider .Slider');
    if (!clubTabSwitches.length || !clubProductSlider)
        return;
    const clubSlider = new Slider(clubProductSlider);
    clubTabSwitches.forEach((tabSwitch) => {
        tabSwitch.addEventListener('click', () => {
            const target = tabSwitch.getAttribute('aria-controls');
            if (target === 'club-rewards') {
                clubSlider.enable();
            }
            else {
                clubSlider.disable();
            }
        });
    });
})();
export {};
